export const GTM_ID = "GTM-W6XFTJL";
